import { colorConstants } from "config/colorConstants";

export const CheckIcon = ({ color = colorConstants.violet }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M5.4 9L7.8 11.4L12.6 6.6M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);
